"use client";

import { useEffect, useRef } from "react";

/**
 * Composant AdSense réutilisable pour l'intégration Google Ads en français
 * @param {Object} props - Propriétés du composant
 * @param {string} props.adSlot - L'ID du slot publicitaire
 * @param {string} [props.adFormat="auto"] - Le format de l'annonce
 * @param {string} [props.adLayout=""] - La clé de layout (pour format fluid)
 * @param {boolean} [props.fullWidthResponsive=true] - Responsive pleine largeur
 * @param {string} [props.className=""] - Classes CSS additionnelles
 * @param {Object} [props.style={}] - Styles inline additionnels
 */
const AdSense = ({ 
  adSlot, 
  adFormat = "auto", 
  adLayout = "", 
  fullWidthResponsive = true,
  className = "",
  style = {}
}) => {
  const adRef = useRef(null);
  const CLIENT_ID = "ca-pub-7645200412475450";

  useEffect(() => {
    // Vérifier si le script AdSense est déjà chargé
    if (typeof window !== 'undefined' && !window.adsbygoogle) {
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${CLIENT_ID}&hl=fr`;
      script.crossOrigin = "anonymous";
      document.head.appendChild(script);
    }

    // Initialiser AdSense après le rendu du composant
    const timer = setTimeout(() => {
      try {
        if (typeof window !== 'undefined' && window.adsbygoogle && adRef.current) {
          (window.adsbygoogle = window.adsbygoogle || []).push({});
        }
      } catch (error) {
        console.error('Erreur AdSense:', error);
      }
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={className}>
      <ins 
        ref={adRef}
        className="adsbygoogle"
        style={{ display: 'block', ...style }}
        data-ad-client={CLIENT_ID}
        data-ad-slot={adSlot}
        data-ad-format={adFormat}
        {...(adLayout && { 'data-ad-layout-key': adLayout })}
        {...(fullWidthResponsive && { 'data-full-width-responsive': 'true' })}
      />
    </div>
  );
};

export default AdSense;

